import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { singleActionDispatched } from "store/single-action-dispatch/action";
import useFeatureFlags from "./useFeatureFlags";
import { REQUIRED_FEATURE_FLAGS } from "helpers/sf_constants";

// A custom hook which takes an action and dispatches it ONLY
// once throughout the lifecycle of the application
const useSingleActionDispatcher = (action) => {
    const dispatch = useDispatch();
    const [isFeatureFlagActive, areFeatureFlagsLoaded] = useFeatureFlags();

    const { current_account, current_user, dispatched_actions } = useSelector((state) => ({
        current_account: state.accounts.current_account,
        current_user: state.Login.current_user,
        dispatched_actions: state.SingleActionDispatch.dispatched_actions
    }));
    
    useEffect(() => {
        if (current_account && current_user && 
            areFeatureFlagsLoaded && isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_REDUCE_APP_INITIAL_LOAD_API) &&
            !dispatched_actions.includes(action?.type)) {
            dispatch(action);
            dispatch(singleActionDispatched(action?.type));
        }
    }, [current_account, current_user, action?.type, dispatched_actions, areFeatureFlagsLoaded]);
}

export default useSingleActionDispatcher